__turbopack_context__.v({
  "contentPageContent": "ContentPageContent-module-scss-module__FeKsPW__contentPageContent",
});
